import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";

import "../../assets/css/wibb/pages/home.scss";
import { store } from "../..";
import { tournamentManagementActions } from "../../features/tourneymgmt/tournamentManagementSlice";
import { useAppSelector } from "../../hooks/reduxHooks";
import { ordinalSuffix } from "../../lib/utils";

export const loader = async () => {
    const masterTournaments =
        store.getState().tournamentmanagement.masterTournaments;
    const masterTournamentsPromise = masterTournaments.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getMasterTournaments());

    await Promise.all([masterTournamentsPromise]);

    return null;
};

const DiscountLodging = (): React.JSX.Element => {
    const { masterTournaments } = useAppSelector(
        state => state.tournamentmanagement,
    );

    return (
        <Container
            className="py-5 discountLodgingContent"
            data-testid="discountLodgingContent"
        >
            <Row>
                <Col>
                    <h2>
                        WE HAVE PARTNERED WITH A NUMBER OF HOTELS TO OFFER
                        FAMILIES PLAYING IN OUR TOURNAMENTS DISCOUNTED ROOM
                        RATES, PLEASE SELECT YOUR TOURNAMENT BELOW FOR MORE
                        INFORMATION
                    </h2>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table striped responsive bordered>
                        <tbody>
                            {masterTournaments
                                .filter(
                                    m =>
                                        new Date().getTime() <
                                        new Date(m.startDate).getTime(),
                                )
                                .map(m => {
                                    const startMonth = new Intl.DateTimeFormat(
                                        "en-US",
                                        {
                                            month: "long",
                                        },
                                    ).format(new Date(m.startDate));

                                    const startDay = new Date(
                                        m.startDate,
                                    ).getDate();

                                    const endMonth = new Intl.DateTimeFormat(
                                        "en-US",
                                        {
                                            month: "long",
                                        },
                                    ).format(new Date(m.endDate));

                                    const endDay = new Date(
                                        m.endDate,
                                    ).getDate();

                                    return (
                                        <tr key={m.id}>
                                            <td width={"30%"}>
                                                {`${startMonth} ${startDay}${ordinalSuffix(startDay)}-${endMonth !== startMonth ? `${endMonth} ` : ""}${endDay}${ordinalSuffix(endDay)}`}
                                            </td>
                                            <td width={"40%"}>
                                                {m.hotelLink ? (
                                                    <a
                                                        href={m.hotelLink}
                                                        target="_blank"
                                                    >
                                                        {m.name}
                                                    </a>
                                                ) : (
                                                    m.name
                                                )}
                                            </td>
                                            <td width={"30%"}>
                                                {m.field.name}
                                            </td>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Container>
    );
};

export default DiscountLodging;
